import axios from '@/axios';

export default {
    namespaced: true,
    state: () => ({
        token: localStorage.getItem('dealerToken') || null,
        dealer: null
    }),
    getters: {
        isAuthenticated: state => !!state.token,
        dealer: state => state.dealer
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
            if (token) {
                localStorage.setItem('dealerToken', token);
            } else {
                localStorage.removeItem('dealerToken');
            }
        },
        setDealer(state, dealer) {
            state.dealer = dealer;
        }
    },
    actions: {
        async login({ commit }, { name, password }) {
            const response = await axios.post('/api/dealer/login', { name, password });
            if (!response.data.success) throw new Error(response.data.error || 'Login failed');
            commit('setToken', response.data.data.token);
            commit('setDealer', response.data.data.dealer);
            return response.data.data.dealer;
        },
        logout({ commit }) {
            commit('setToken', null);
            commit('setDealer', null);
        },
        async fetchMe({ commit }) {
            const response = await axios.get('/api/dealer/me');
            if (!response.data.success) throw new Error(response.data.error);
            commit('setDealer', response.data.data);
        },
        async ssoLogin({ commit }, { customerId, token, ts }) {
            const response = await axios.post('/api/dealer/sso', { customerId, token, ts });
            if (!response.data.success) throw new Error(response.data.error || 'SSO failed');
            commit('setToken', response.data.data.token);
            commit('setDealer', response.data.data.dealer);
            return response.data.data.dealer;
        },
        async loginWithToken({ commit, dispatch }, token) {
            commit('setToken', token);
            try {
                await dispatch('fetchMe');
            } catch (e) {
                commit('setToken', null);
                throw e;
            }
        }
    }
};
